import {enqueueSnackbar} from 'notistack';

import {API_BASE_URL, BASKET_INVALID_PRODUCTS_REMOVED} from '../../constants';
import {
  JwtRequestDto,
  JwtResponseDto,
  SearchAssetInformationDto,
} from '../../models';
import {post} from '../api';

export function getValidBasket(
  token: string,
  basket: SearchAssetInformationDto[],
  setBasket: (basket: SearchAssetInformationDto[]) => void,
) {
  const list: {id: string; download: string}[] = basket.map(item => ({
    id: item.id,
    download: item.download,
  }));
  post(`${API_BASE_URL}/validateWarenkorb`, {
    data: list,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(res => {
      const result: string[] = res.data;
      if (result.length < basket.length) {
        enqueueSnackbar(BASKET_INVALID_PRODUCTS_REMOVED, {variant: 'info'});
      }
      const newBasket: SearchAssetInformationDto[] = basket.filter(item =>
        result.includes(item.id),
      );
      setBasket(newBasket);
    })
    .catch(err => {
      if (err?.response?.status === 400) {
        enqueueSnackbar(BASKET_INVALID_PRODUCTS_REMOVED, {variant: 'info'});

        const newBasket: SearchAssetInformationDto[] = [];
        setBasket(newBasket);
      }
    });
}

export function logOff(token: string) {
  post(`${API_BASE_URL}/logoff`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'text/plain',
    },
  }).catch(err => {
    console.error('Error logging off:', err);
  });
}

export function logIn(credentials: JwtRequestDto): Promise<JwtResponseDto> {
  return post(`${API_BASE_URL}/login`, {
    data: JSON.stringify(credentials),
    responseType: 'json',
    headers: {'Content-Type': 'application/json'},
  }).then(res => res.data);
}
